import { getPreviousQuarter } from "../../utils/dateUtils";

export const HISTORY_CONSTANTS = {
  BREADCRUMB: {
    TITLE: "History",
    PATH: "/history",
  },
  DEFAULT_USER: {
    USERNAME: "",
  },
  QUERY_PARAMS: {
    DEFAULT_YEAR:  getPreviousQuarter().year.toString(),
    DEFAULT_QUARTER: getPreviousQuarter().quarter.toString(),
  },
  STATES: {
    LOADING: {
      MESSAGE: "Loading reviews...",
    },
    ERROR: {
      MESSAGE: "Error loading reviews: ",
    },
    EMPTY: {
      TITLE: "No reviews found",
      SUBTITLE: "There are no applications available for your review at this time.",
      ICON: {
        SIZE: "w-12 h-12",
        COLOR: "text-gray-400",
      },
    },
  },
  LAYOUT: {
    MAX_WIDTH: "max-w-9xl",
    PADDING: "px-4 sm:px-6 lg:px-8",
    SPACING: {
      BREADCRUMB: "mb-6",
      CONTENT: "space-y-4",
    },
  },
  HEADER: {
    COUNTER_TEXT: "applications to review",
  },
};
